<template>
    <section class="section">
        <vue-headful
            title="TZ Design Box - Upload Price"
            description="TZ Design Box"
        />

        <div class="columns">
            <div class="column is-2 menu-vert">
                <MenuVert :currentactive="'catalog-i18n'" />
            </div>
            <div class="column is-10" style="margin-top:25px;">
                <tr-title-bar
                :translatedTrUnits="translatedTrUnits"
                :totalTrUnits="totalTrUnits"
                v-if="catalog"
                >
                    Catalog {{ catalog.props.label.val }} Translation
                </tr-title-bar>
                <div class="columns is-multiline">
                    <component :is="child.tag" v-for="(child, idx) in catalog.children" :key="idx"
                        v-bind="child"
                        :index="idx"
                        :tracker="tracker"
                        @edit-tr="editTranslation"
                        @select="selectItem"
                    ></component>
                </div>
                <tr-edit
                    :trackerIdx="currentTrackerIdx"
                    :tid="currentTid"
                    :translatedTrUnits="translatedTrUnits"
                    :totalTrUnits="totalTrUnits"
                    @move-tr="selectTr($event)"
                    @close="closeTrEdit"
                />
            </div>
        </div>
    </section>
</template>

<script>
import TranslationBaseView  from "@/views/TranslationBaseView"
import { mapGetters }       from 'vuex'

export default {
    name: "CatalogView",
    extends: TranslationBaseView,
    data () {
        return {
            id: "",
            catalog: {
                id : "", props: {label: {val: ""}}
            },
            currentTrackerIdx: null,
            currentTid: null,
            tracker:    []
        }
    },
    computed: {
        ...mapGetters ("translation", ["sourceName", "targetName"]),
    },
    watch : {
        catalogs () {
            this._updateRoot ({ id : this.id })
        }
    },
    methods: {
        _clearRoot () {
            this.catalog = { props: {label: {val: ""}}, id: ""}
        },
        _updateRoot ({ id }) {
            this.id = id
            const catalog = this.catalogs.find(c => c.id == id)
            if (catalog) this.catalog = catalog
        },
        selectItem(idx) {
            let obj = this.catalog.children [idx]
            this.$router.push ("/catalog/" + obj.url)
            console.log ("Select", idx, obj.url)
        }
    },
    mounted () {
        const params = this.$route.params
        if (! this.catalogs.find(c => c.id == params.id)) {
            console.log ("Load Catalog Info")
            this.$store.dispatch ("translation/loadCatalogs", {self:this})
        } else {
            this.updateRoot (params)
        }
    }
}
</script>

<style>

</style>